/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Callback, IAccountPublic, IErrorObject} from "../../../../../types/platform/universe";
import {YesNoDialogComponent} from "../../../platform/base/components/yes-no-dialog/yes-no-dialog.component";

import {Directive, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Overlay} from "@angular/cdk/overlay";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {SessionService} from "../../../platform/base/services/session.service";
import {Guests2Service} from "../../guests2/guests2.service";
import {SessionableComponent} from "../../../platform/base/components/sessionable.component";
import {MessageDialogComponent} from "../../base/components/message-dialog/message-dialog.component";

import {environment} from "../../../../environments/environment";
import {TranslateService} from "@ngx-translate/core";

@Directive()
export abstract class BaseProfileComponent extends SessionableComponent implements OnInit {

	//protected id: string;
	protected create: Date;
	protected type: string;
	protected nickname: string;
	protected username: string;

	protected params: any = {};

	public studio_url: string = "";

	public manages: any[] = [];
	public manage: any = {};

	public selected_studios: any[] = [];
	public studios: any[] = [];
	public studio: any = {};
	public parent_studio: any;

	public account: any;
	public user_id: string = "";

	/**
	 *
	 * @param session
	 * @param overlay
	 * @param accountService
	 * @param matDialog
	 * @param snackbar
	 * @param router
	 * @param route
	 */
	constructor(
		protected session: SessionService,
		protected overlay: Overlay,
		protected accountService: Guests2Service,
		protected matDialog: MatDialog,
		protected snackbar: MatSnackBar,
		protected router: Router,
		protected route: ActivatedRoute,
		public translate: TranslateService
	) {
		super(session);
	}

	/**
	 * @returns Promise
	 */
	protected async sha256(text: string): Promise<string> {
		const uint8 = new TextEncoder().encode(text)
		const digest = await crypto.subtle.digest('SHA-256', uint8)
		return Array.from(new Uint8Array(digest)).map(v => v.toString(16).padStart(2, '0')).join('');
	}

	/**
	 * @returns none
	 */
	protected HashValue(S: string, length: number, callback: Callback<string>): void {
		this.sha256(S).then((hash): void => {
			callback(null, hash.slice(0, length));
		}).catch((error): void => {
			callback(error, null);
		});
	}

	/**
	 * @returns any[]
	 */
	protected difference(array1: any[], array2: any[]): any[] {
		const result: any = [];
		array1.forEach((item1) => {
			let found: boolean = false;
			for (let index = 0; index < array2.length; index++) {　// Because break is required.
				found = (item1.account.user_id === array2[index].account.user_id);
				if (found) {
					break;
				}
			}
			if (!found) {
				result.push(item1);
			}
		})
		return result;
	}

	/**/
	private translateIt(S: string): string {
		let result: string = "";
		if (S) {
			result = this.translate.instant(S);
		}
		return result;
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private messageDialog(data: { content: { title: string, message: string, tag: string } }, callback: (result: any) => void): void {
		if (data) {

			const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
				width: "30%",
				minWidth: "320px",
				height: "fit-content",
				data: data, // {content: {title: "", message: , tag: ""}}
				disableClose: true,
			});

			dialog.afterClosed().subscribe((result: any): void => {
				callback(result);
			});

		}
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	protected errorDialog(error: IErrorObject, callback: (result: any) => void = (error: IErrorObject) => {
	}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: error.message, tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}

	/**
	 * メッセージ表示
	 * @param message
	 */
	protected messageBar(message: string): void {
		if (message) {
			this.snackbar.open(message, "Close", {
				panelClass: ["message-snackbar"]
			});
		}
	}

	/**
	 *
	 * @param hash
	 * @param plain
	 * @param callback
	 */
	protected hashEqual(hash: string, plain: string, callback: Callback<boolean>): void {
		this.HashValue(plain, 10, (error, hashed_target) => {
			callback(error, (hashed_target === hash));
		});
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.getSession((error: IErrorObject, session: any): void => {
			if (!error) {
				this.create = session.create;
				this.username = session.username;
				this.route.queryParams.subscribe(params => {
					this.params = params;
					if (this.params.i) {
						this.user_id = decodeURIComponent(this.params.i);
					}
					//	const user_id = "5fbb62cbbb667c59ad0c694b";
					this.getUser(this.user_id, (error: IErrorObject, account: any): void => {
						if (!error) {
							this.account = account;
							this.draw(this.account);
						} else {
							this.errorDialog(error);
						}
					});
				});
			} else {
				this.errorDialog(error);
			}
		});
	}

	/**
	 * @returns none
	 */
	protected nameEqual(accounts: any[], hashed_name: string, callback: Callback<any>): void {
		accounts.forEach((account: { account: any, type: string }) => {
			if (account.account.username) {
				this.hashEqual(hashed_name, account.account.username, (error: any, match: boolean) => {
					if (!error) {
						if (match) {
							callback(null, account);
						} else {
							callback(null, null);
						}
					} else {
						callback(error, null);
					}
				})
			}
		});
	}

	/**
	 * @returns none
	 */
	protected getAllManage(): void {
		this.manages = [environment.default];
	}

	/**
	 * @returns none
	 */

	protected draw(account: any): void {

		this.type = account.type;
		this.nickname = account.nickname;

		this.getAllManage();

		this.readFrom(account);

		let hashed_studio_name: string = "";

		if (this.params.s) {
			hashed_studio_name = decodeURIComponent(this.params.s);
		}

		if (hashed_studio_name) {　// url指定あり
			this.nameEqual(this.studios, hashed_studio_name, (error: IErrorObject, studio: any) => {
				if (!error) {
					if (studio) {
						this.studios = [studio];
						this.parent_studio = studio;
					}
				}
			});
		}

		this.HashValue(this.username, 10, (error, username_hash) => {
			if (!error) {
				this.studio_url = environment.displayServerName + "?" + "s=" + encodeURIComponent(username_hash);
			} else {
				this.errorDialog(error);
			}
		});
	}

	/**
	 * アカウント参照
	 * @param user_id
	 * @param callback
	 */
	protected getUser(user_id: string, callback: Callback<IAccountPublic>): void {
		this.Progress(true);
		this.accountService.get_user(user_id, (error: IErrorObject, account: IAccountPublic): void => {
			if (!error) {
				callback(null, account);
			} else {
				callback(error, null);
			}
			this.Progress(false);
		});
	}

	/**
	 * アカウント更新
	 * @param user_id
	 * @param data
	 * @param callback
	 */
	protected putUser(user_id: string, data: object, callback: Callback<IAccountPublic>): void {
		this.Progress(true);
		this.accountService.put_user(user_id, data, (error: IErrorObject, result: IAccountPublic): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
			this.Progress(false);
		});
	}

	/**
	 * @returns none
	 */
	protected addItem(user: any): void {
		const user_id = user.user_id;
		this.onMakeRelation(user_id, "belongs");
	}

	/**
	 * @returns none
	 */
	protected removeItem(user: any): void {
		const to_id = user.user_id;
		this.onBreakRelation(to_id, "belongs");
	}

	/**
	 * リレーション
	 * @param to_id
	 * @param type
	 * @param callback
	 */
	protected makeRelation(to_id: string, type: string, callback: Callback<object>): void {
		this.Progress(true);
		this.accountService.make_relation(this.account?.user_id, to_id, type, (error: IErrorObject, result: object): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
			this.Progress(false);
		});
	}

	/**
	 * リレーション
	 * @param from
	 * @param to
	 * @param type
	 * @param callback
	 */
	protected makeRelationTo(from: string, to: string, type: string, callback: Callback<object>): void {
		this.Progress(true);
		this.accountService.make_relation_to(from, to, type, (error: IErrorObject, result: object): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
			this.Progress(false);
		});
	}

	/**
	 * リレーション削除
	 * @param user_id
	 * @param to_id
	 * @param type
	 * @param callback
	 */
	protected breakRelation(user_id: string, to_id: string, type: string, callback: Callback<object>): void {
		this.Progress(true);
		this.accountService.break_relation(user_id, to_id, type, (error: IErrorObject, result: object): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
			this.Progress(false);
		});
	}

	/**
	 * @returns none
	 */
	protected children(user_id: string, callback: Callback<any>): void {
		this.accountService.relation_from_user(user_id, "belongs", {}, (error, companies: { account: any, enabled: boolean, from_id: any, to_id: any, type: string }[]) => {
			if (!error) {
				callback(null, companies);
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * @returns none
	 */
	protected readFrom(content: any): void {
	}

	/**
	 * @returns none
	 */
	private update(user_id: string, data: IAccountPublic, callback: Callback<IAccountPublic>): void {
		this.accountService.put_user(user_id, {content: data}, (error: IErrorObject, result: IAccountPublic): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * アカウント参照
	 * @param id
	 * @param callback
	 */
	private get(id: string, callback: Callback<IAccountPublic>): void {
		this.accountService.get_user(id, (error: IErrorObject, result: IAccountPublic): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * @returns none
	 */
	public writeTo(content: any): any {
	}

	/**
	 * @returns none
	 */
	public onAccept(): void {
		const user = this.account;
		this.get(user.user_id, (error: IErrorObject, account: IAccountPublic): void => {　// refresh
			if (!error) {
				this.writeTo(account);
				this.update(user.user_id, account, (error: IErrorObject, result: IAccountPublic): void => {
					if (!error) {
						const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
							width: "30%",
							minWidth: "320px",
							height: "fit-content",
							data: {content: {title: "Update.", message: this.translate.instant('更新しました。'), tag: ""}},
							disableClose: true,
						});

						dialog.afterClosed().subscribe((result: any): void => {
							this.draw(account);
						});
					} else {
						this.errorDialog(error);
					}
				});
			} else {
				this.errorDialog(error);
			}
		});
	}

	/**
	 * @returns none
	 */
	private setParent(user_id: any, callback: (error: any, result: any) => void): void {
		this.account.parent = user_id;
		this.accountService.put_user(this.account.user_id, {content: this.account}, callback);
	}

	/**
	 * @returns none
	 */
	public onSetParent(parent: any): void {
		const resultDialogContent: any = {title: "追加", message: "追加しますか?", ok_button: "追加"};
		const dialog: MatDialogRef<any> = this.matDialog.open(YesNoDialogComponent, {
			width: "50%",
			minWidth: "320px",
			height: "fit-content",
			data: {
				session: this.currentSession,
				content: resultDialogContent,
			},
			disableClose: true,
		});
		dialog.afterClosed().subscribe((result: object) => {

			if (result) {
				this.setParent(parent, (error: any, result: any) => {
					if (!error) {
						this.messageDialog({content: {title: this.translateIt("メッセージ"), message: this.translateIt("正常"), tag: ""}}, () => {
						});
					} else {
						this.errorDialog(error, (result: any) => {
						});
					}
				});
			} // if not cancel then

		});
	}

	/**
	 * @returns none
	 */
	public onRemoveParent(): void {
		const resultDialogContent: any = {title: "削除", message: "削除しますか?", ok_button: "削除"};
		const dialog: MatDialogRef<any> = this.matDialog.open(YesNoDialogComponent, {
			width: "50%",
			minWidth: "320px",
			height: "fit-content",
			data: {
				session: this.currentSession,
				content: resultDialogContent,
			},
			disableClose: true,
		});
		dialog.afterClosed().subscribe((result: object) => {
			if (result) { // if not cancel then
				this.setParent(null, (error: any, result: any) => {
					if (!error) {
						this.messageDialog({content: {title: this.translate.instant(""), message: this.translate.instant(""), tag: ""}}, () => {
						});
					} else {
						this.errorDialog(error, (result: any) => {
						});
					}
				});
			}
		});
	}

	/**
	 * @returns none
	 */
	public onMakeRelation(user_id: string, type: string): void {

	}

	/**
	 * @returns none
	 */
	public onBreakRelation(to_id: string, type: string): void {

	}

	/**
	 * @returns none
	 */
	protected relationTo(target_type: string, relation_type: string, callback: Callback<any>): void {
		const result: any[] = [];
		this.accountService.relation_to(this.account?.user_id, relation_type, {}, (error, results) => {
			if (!error) {
				results.forEach((user: any) => {
					if (user.account.type === target_type) {
						result.push(user);
					}
				})
				callback(null, result);
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * @returns none
	 */
	protected relationToUser(from_id: string, target_type: string, relation_type: string, callback: Callback<any>): void {
		const result: any[] = [];
		this.accountService.relation_to_user(from_id, relation_type, {}, (error, results) => {
			if (!error) {
				results.forEach((user: any) => {
					if (user.account.type === target_type) {
						result.push(user);
					}
				})
				callback(null, result);
			} else {
				callback(error, null);
			}
		});
	}


}
